<template>
<div class="chapter">
<div class="inner_page">
<div id="weitgmefm">
<div class="generated-style-2"></div>
<div class="generated-style-2">
<p class="basic-paragraph-override" xml:lang="en-us" xmlns:xml="http://www.w3.org/XML/1998/namespace"><span class="generated-style"><img alt="With Edwards Governors Mansion display type BITMAP.tif" class="generated-style" src="Images/WithEdwardsGovernor_fmt1.jpeg"/></span></p>
</div>
<div class="generated-style-2">
<p class="basic-paragraph-override" xml:lang="en-us" xmlns:xml="http://www.w3.org/XML/1998/namespace"><img alt="PELOGO.TIF" class="generated-style" src="Images/PELOGO_fmt.jpeg"/></p>
<p class="basic-paragraph-override" xml:lang="en-us" xmlns:xml="http://www.w3.org/XML/1998/namespace"><span class="no-style-override-1">PELICAN PUBLISHING COMPANY</span></p>
<p class="basic-paragraph-override" xml:lang="en-us" xmlns:xml="http://www.w3.org/XML/1998/namespace"><span class="no-style-override-2">Gretna</span> <span class="no-style-override-2">2012</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?194f5860